import whiteStatusbar from 'url:../../../assets/images/white-statusbar.webp';
import exercisesDetails1 from 'url:../../../assets/images/lunges-details-1.webp';
import exercisesDetails2 from 'url:../../../assets/images/lunges-details-2.webp';
import exercisesDetails3 from 'url:../../../assets/images/lunges-details-3.webp';
import exercisesDetails4 from 'url:../../../assets/images/lunges-details-4.webp';
import exercisesDetails5 from 'url:../../../assets/images/lunges-details-5.webp';
import exercisesDetails6 from 'url:../../../assets/images/lunges-details-6.webp';

export const lungesDetailsAssets = {
  whiteStatusbar,
  exercisesDetails1,
  exercisesDetails2,
  exercisesDetails3,
  exercisesDetails4,
  exercisesDetails5,
  exercisesDetails6,
} as const;

export const lungesDetailsAssetList = Object.values(lungesDetailsAssets);
